import Vue from 'vue'
import Router from 'vue-router'
import WebFont from 'webfontloader'

Vue.use(Router)

// Code Splitting
const Root = (resolve) => {
    import('@/components/Root').then((module) => {
        resolve(module)
    })
}

const Book = (resolve) => {
    import('@/components/Book').then((module) => {
        resolve(module)
    })
}

var routes = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'root',
            component: Root
        },
        {
            path: '/book/:consignmentReturnCode',
            name: 'book',
            component: Book,
            props: true
        },
        {
            path: '*',
            name: '404',
            component: Root
        }
    ]
})

routes.beforeEach((to, from, next) => {
    WebFont.load({
        classes: false,
        active: () => {
            next()
        },
        inactive: () => {
            next(false)
        },
        custom: {
            families: ['FontAwesome'],
            urls: ['https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css'],
            testStrings: {
                'FontAwesome': '\uf118\uf119'
            }
        }
    })
})

export default routes
